import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { BaseAuthElement } from '@adobe/edex/ui/components/base.element';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { ResourceCardSchema } from '@adobe/edex/ui/types';
import '@adobe/edex/ui/components/wrappers/resource-card-wrapper';
import '@adobe/edex/ui/components/resource/related-resource-shelf/related-resource-shelf.scss';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';

@customElement(EdexTagName.relatedResourcesShelf)
export class RelatedResourcesShelf extends BaseAuthElement {
  get useLightDom() {
    return true;
  }

  relatedResources: ResourceCardSchema[];

  static get properties() {
    return {
      ...super.properties,
      relatedResources: { type: Array },
    };
  }

  connectedCallback() {
    super.connectedCallback();
  }

  render() {
    const { relatedResources } = this;
    return html`
      <div class="related-resources-container">
        ${relatedResources?.length > 0
          ? html`
              <div>
                <h2 class="related-resources-container-header">${$t(I18nKey.reltedResourcesHeader)}</h2>
              </div>
              <div class="related-resources-teaching-resources">
                ${relatedResources.map(
                  (resource) =>
                    html`
                      <edex-resource-card-wrapper
                        class="similar-resource-card"
                        .resource=${resource}
                      ></edex-resource-card-wrapper>
                    `
                )}
              </div>
            `
          : null}
      </div>
    `;
  }
}
